__turbopack_context__.v({
  "btn-full": "SX31xW_btn-full",
  "cancel-link": "SX31xW_cancel-link",
  "centered": "SX31xW_centered",
  "close-btn": "SX31xW_close-btn",
  "confirm": "SX31xW_confirm",
  "confirm-modal-box": "SX31xW_confirm-modal-box",
  "confirm-modal-box--cart": "SX31xW_confirm-modal-box--cart",
  "confirm-modal-inner": "SX31xW_confirm-modal-inner",
  "confirm-overlay": "SX31xW_confirm-overlay",
  "delete": "SX31xW_delete",
  "description": "SX31xW_description",
  "header-icon": "SX31xW_header-icon",
  "header-icon-svg": "SX31xW_header-icon-svg",
  "header-row": "SX31xW_header-row",
  "modal-content": "SX31xW_modal-content",
  "modal-footer": "SX31xW_modal-footer",
  "modal-header": "SX31xW_modal-header",
  "tertiary": "SX31xW_tertiary",
  "title": "SX31xW_title",
});
